import React, { useEffect, useState } from "react";
import "./Hero.css";

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const t = setTimeout(() => setIsVisible(true), 120);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth - 0.5) * 20,
        y: (e.clientY / window.innerHeight - 0.5) * 20
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div id="home" className="hero-section">
      <div className="hero-background">
        <div className="gradient-orb orb-1" style={{
          transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`
        }}></div>
        <div className="gradient-orb orb-2" style={{
          transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)`
        }}></div>
        <div className="gradient-orb orb-3" style={{
          transform: `translate(${mousePosition.y}px, ${mousePosition.x}px)`
        }}></div>
      </div>

      <div className={`container hero-content ${isVisible ? "is-visible" : ""}`}>
        <div className="hero-badge">
          <span className="badge-dot"></span>
          Trusted by Top Gaming Operators
        </div>

        <h1 className="hero-title">
          360 Gaming Labs
        </h1>
        
        <h2 className="hero-subtitle-main">
          Your Complete 360° Partner in <span className="gradient-text">iGaming Innovation</span>
        </h2>

        <p className="hero-description">
          The #1 trusted Partner for High-Performance Sports Exchange,<br className="d-none d-md-block" />
          Sportsbook & Casino Solutions.
        </p>

        <div className="hero-buttons">
          <a href="#contact" className="btn-primary">
            <span>Get in Touch</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </a>
          <a href="#demo" className="btn-secondary">
            <span>Explore Demo Site</span>
          </a>
        </div>

        {/* Stats Section */}
        <div className="hero-stats">
          <div className="stat-item">
            <div className="stat-number">50+</div>
            <div className="stat-label">Active Platforms</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">10 Days</div>
            <div className="stat-label">Launch Time</div>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>
      </div>

      <div className="floating-elements">
        <div className="float-element element-1"></div>
        <div className="float-element element-2"></div>
        <div className="float-element element-3"></div>
        <div className="float-element element-4"></div>
      </div>
    </div>
  );
}
